import type { BundleConfig } from './config-tab';

const STORAGE_KEY = 'wexler:bundle:formConfigPrefs:v1';

type BundleConfigPrefs = Omit<BundleConfig, 'name' | 'subheading'>;

export function loadBundleFormConfigPrefs(): Partial<BundleConfigPrefs> | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed as Partial<BundleConfigPrefs>;
  } catch {
    return null;
  }
}

export function saveBundleFormConfigPrefs(config: BundleConfig): void {
  try {
    const { name: _name, subheading: _subheading, ...prefs } = config;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  } catch {
    // localStorage may be unavailable (private mode, quota); silently ignore.
  }
}
